import React, { FC, useState, useEffect } from 'react';
import { apiService } from 'utils/api';
import { getPolygonSurge } from 'utils/firebase';
import SurgeApplyNowSection from '../surge-tabs/surge-apply-now';
import { InstantTabPayload, PolygonSurgeTabProps } from '../surge-tabs/types';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderSurgeType } from 'models/surge.model';

const orderUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const PolygonSurgeApplyNow: FC<PolygonSurgeTabProps> = ({
  confirm,
  setLoading,
  onClose,
  cokitchen_polygon_id,
  activeSurge,
  setActiveSurge
}) => {
  const [value, setValue] = useState<InstantTabPayload>({
    logistics_surge: '',
    logistics_surge_type: ''
  });

  const setPolygonSurge = async () => {
    try {
      const url = 'logistics/super-admin/surge/polygon/instant';
      const res = await apiService.post(url, {
        data: {
          ...value,
          cokitchen_polygon_id
        },
        baseUrl: orderUrl
      });
      const data = res?.data?.general_surge_history;
      return data;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (confirm === 'Apply Now') {
      (async () => {
        try {
          setLoading(true);
          await setPolygonSurge();
          toast(<ToastMessage type='success' message='Updated successfully' />);
          onClose();
        } catch (error) {
          toast(<ToastMessage type='error' message='There was an error updating surge' />);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [confirm]);
  useEffect(() => {
    if (cokitchen_polygon_id) {
      getPolygonSurge(cokitchen_polygon_id, (doc: OrderSurgeType) => {
        const { logistics_surge = '', logistics_surge_type = '' } = doc;
        setActiveSurge?.({
          logistics_surge,
          logistics_surge_type
        });
      });
    }
  }, [cokitchen_polygon_id]);

  return <SurgeApplyNowSection value={value} setValue={setValue} activeSurge={activeSurge} />;
};

export default PolygonSurgeApplyNow;
